import React, { useState } from 'react';
import { Mail, ArrowRight, CheckCircle } from 'lucide-react';
import { getFunctionsUrl } from '../utils/functions';
import './NewsletterSignup.css';

const NewsletterSignup: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      const functionsUrl = await getFunctionsUrl();
      const response = await fetch(`${functionsUrl}/submitNewsletterSignup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email })
      });

      const result = await response.json();
      
      if (!result.success) {
        throw new Error(result.error || 'Failed to subscribe');
      }

      setIsSubmitted(true);
      setEmail('');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <section id="newsletter" className="newsletter-section">
        <div className="container">
          <div className="newsletter-content newsletter-success">
            <CheckCircle size={32} className="success-icon" />
            <h3>You're subscribed!</h3>
            <p>Thank you for joining our newsletter. You'll receive updates about our programs and events.</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="newsletter" className="newsletter-section">
      <div className="container">
        <div className="newsletter-content">
          <div className="newsletter-text">
            <Mail size={28} className="newsletter-icon" />
            <div>
              <h3>Stay Connected</h3>
              <p>Subscribe to receive updates about our scholarships, GLO program, and upcoming events.</p>
            </div>
          </div>
          
          <form onSubmit={handleSubmit} className="newsletter-form">
            <div className="newsletter-input-group">
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
                aria-label="Email address"
              />
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                {!isSubmitting && <ArrowRight size={18} />}
              </button>
            </div>
            {error && <p className="newsletter-error">{error}</p>}
          </form>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSignup;
